<template>
    <div style="display: contents" v-if="hasActiveIntegration">
        <v-btn icon @click="showSyncDialog = true">
            <v-icon :class="$eventBusUtility.iconAppBarColor">mdi-sync</v-icon>
        </v-btn>

        <v-dialog v-model="showSyncDialog" max-width="600">
            <v-card class="background-2 round-card">
                <v-card-title>
                    <p>Sincronizzazione</p>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showSyncDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pt-4 px-16">
                    <v-row class="ma-0" justify="center">
                        <v-col cols="12">
                            <v-btn 
                                block
                                outlined
                                color="blue"
                                large
                                @click="syncImport"
                                :loading="importLoading">
                                <v-icon left :size="22">mdi-cloud-download-outline</v-icon>
                                Sincronizza in entrata
                            </v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-btn
                                block
                                outlined
                                color="green"
                                large
                                @click="syncExport"
                                :loading="exportLoading">
                                <v-icon left :size="22">mdi-cloud-upload-outline</v-icon>
                                Sincronizza in uscita
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="showSyncDialog = false">
                        Chiudi
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'sync-menu',
    
    data: () => ({
        showSyncDialog: false,
        importLoading: false,
        exportLoading: false,
        hasActiveIntegration: false,
        loading: true
    }),

    mounted() {
        this.checkIntegrationStatus()
    },

    methods: {
        checkIntegrationStatus() {
            if(this.$store.getters.checkModelPermissions('setting')) {
                this.axios.get('integrationssettings').then(response => {
                    if (response.data.data && 
                        Object.keys(response.data.data).length > 0 && 
                        response.data.data.integrated_application && 
                        response.data.data.integrated_application !== 'nothing') {
                        this.hasActiveIntegration = true
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },

        syncImport() {
            this.importLoading = true
            this.axios.get('import').then(response => {
                this.$store.commit('setSnackbar', {
                    timeout: 6000,
                    text: 'Importazione avviata',
                    value: true,
                    color: 'success'
                })
                this.importLoading = false
                this.showSyncDialog = false
            }).catch(() => {
                this.importLoading = false
            })
        },

        syncExport() {
            this.exportLoading = true
            this.axios.get('export').then(response => {
                this.$store.commit('setSnackbar', {
                    timeout: 6000,
                    text: 'Esportazione avviata',
                    value: true, 
                    color: 'success'
                })
                this.exportLoading = false
                this.showSyncDialog = false
            }).catch(() => {
                this.exportLoading = false
            })
        }
    }
}
</script>
